var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chatbot-tune-preview" }, [
    _c("div", { staticClass: "tune-plugin" }, [
      _c("div", { staticClass: "plugin-wrapper" }, [
        _c("div", { staticClass: "plugin-header" }, [
          _c(
            "div",
            { staticClass: "avatar" },
            [
              _c("SupsisSVG"),
              _vm._v(" "),
              _c("div", { staticClass: "indicator" }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.companyName)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "status" }, [_vm._v("Online")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "plugin-content" }, [
          _c("div", { staticClass: "welcome" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.welcomeText) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "reply-list" }, [
      _c("div", { staticClass: "reply" }, [_vm._v("FAQ")]),
      _vm._v(" "),
      _c("div", { staticClass: "reply" }, [_vm._v("About Recruitee")]),
      _vm._v(" "),
      _c("div", { staticClass: "reply" }, [_vm._v("Pricing")]),
      _vm._v(" "),
      _c("div", { staticClass: "reply" }, [_vm._v("Contact Us")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }